export default "__VITE_ASSET__CqkRXTRg__"